import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Season from '../components/Season/index.jsx';
import { BreakpointMobile } from '../constants/ui';
import { Header } from '../components/index.jsx';
import { useViewport } from '../hooks';
import { getSidebarLinksMap } from '../utils/ui';

const SeasonPage = () => {
  const { t } = useTranslation();
  const SidebarLinksMap = getSidebarLinksMap(t);
  const { widthViewport } = useViewport();
  const { selectedSeason } = useSelector((state) => state.fields);

  return (
    <>
      {widthViewport > BreakpointMobile && (
        <Header title={selectedSeason.id ? SidebarLinksMap.season.titleSecondary : SidebarLinksMap.season.title} t={t} />
      )}
      <main className="main">
        <Season t={t} />
      </main>
    </>
  );
};

export default SeasonPage;
